import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Constants} from "_@shared/models/constants";

export interface ServiceCenterStatus {
  id: string,
  sca: string,
  scn: string,
  date: string,
  cat: string,
  starttime: string,
  endtime: string,
  percent: string,
  notes: string,
  name: string,
  closed: string,
  color: string,
  latitude: string,
  longitude: string
}

export interface ServiceCenterForecastResponse {
  sc: string,
  date: string,
  currenthightemp: string,
  currentlowtemp: string,
  currentforecast: string
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) {
  }
  
  getServiceCenterStatus(): Observable<ServiceCenterStatus[]> {
    return this.http.get<ServiceCenterStatus[]>(Constants.GET_SERVICE_CENTERS_STATUS);
  }
  
  getServiceCenterWeatherForecast(svcCode: string): Observable<ServiceCenterForecastResponse> {
    return this.http.get<ServiceCenterForecastResponse>(Constants.GET_WEATHER_FORECAST_STATUS + '/' + svcCode);
  }
  
}
